<template>
	<div class="lessons-list">
		<!-- Header -->
		<div class="lessons-list__header">
			<div class="lessons-list__header-left">
				<button
					class="lessons-list__back-btn"
					type="button"
					@click="$emit('back')"
					title="Назад к модулям"
				>
					← Назад
				</button>
				<h3 class="lessons-list__title">Уроки модуля: {{ moduleName }}</h3>
			</div>
			<button
				class="lessons-list__add-btn"
				type="button"
				@click="$emit('create-lesson')"
			>
				<span class="lessons-list__add-icon">+</span>
				Добавить урок
			</button>
		</div>

		<!-- Loading -->
		<div v-if="loading" class="lessons-list__loading">
			<div class="spinner"></div>
			<p>Загрузка уроков...</p>
		</div>

		<!-- Empty State -->
		<div v-else-if="lessons.length === 0" class="lessons-list__empty">
			<p class="lessons-list__empty-text">Уроки еще не созданы</p>
			<button
				class="lessons-list__empty-btn"
				type="button"
				@click="$emit('create-lesson')"
			>
				Создать первый урок
			</button>
		</div>

		<!-- Lessons List -->
		<div v-else class="lessons-list__items">
			<draggable
				v-model="localLessons"
				@end="handleReorder"
				item-key="id"
				handle=".lesson-card__drag-handle"
			>
				<template #item="{ element: lesson }">
					<LessonCard
						:lesson="lesson"
						@edit="$emit('edit-lesson', lesson)"
						@delete="$emit('delete-lesson', lesson)"
						@view="$emit('view-lesson', lesson)"
					/>
				</template>
			</draggable>
		</div>
	</div>
</template>

<script>
import LessonCard from './LessonCard.vue'
import draggable from 'vuedraggable'

export default {
	name: 'LessonsList',
	components: {
		LessonCard,
		draggable,
	},
	props: {
		lessons: {
			type: Array,
			default: () => [],
		},
		moduleName: {
			type: String,
			default: 'Модуль',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			localLessons: [...this.lessons],
		}
	},
	watch: {
		lessons: {
			handler(newLessons) {
				this.localLessons = [...newLessons]
			},
			deep: true,
		},
	},
	methods: {
		handleReorder() {
			const lessonIds = this.localLessons.map(l => l.id)
			this.$emit('reorder-lessons', lessonIds)
		},
	},
}
</script>

<style scoped>
.lessons-list {
	width: 100%;
	padding: 20px;
	background-color: #ffffff;
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Header */
.lessons-list__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
	gap: 16px;
}

.lessons-list__header-left {
	display: flex;
	align-items: center;
	gap: 16px;
	flex: 1;
}

.lessons-list__back-btn {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 16px;
	background-color: #f5f5f5;
	border: none;
	border-radius: 8px;
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
}

.lessons-list__back-btn:hover {
	background-color: #e8e8e8;
	color: #252641;
}

.lessons-list__title {
	color: #252641;
	font-family: 'Poppins', Helvetica;
	font-size: 22px;
	font-weight: 600;
	margin: 0;
}

.lessons-list__add-btn {
	display: flex;
	align-items: center;
	gap: 8px;
	background-color: #0095ec;
	color: #ffffff;
	border: none;
	border-radius: 8px;
	padding: 10px 20px;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
	white-space: nowrap;
}

.lessons-list__add-btn:hover {
	background-color: #0077be;
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 149, 236, 0.3);
}

.lessons-list__add-icon {
	font-size: 20px;
	font-weight: 600;
}

/* Loading */
.lessons-list__loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
}

.spinner {
	width: 40px;
	height: 40px;
	border: 4px solid #f3f3f3;
	border-top: 4px solid #0095ec;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin-bottom: 16px;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

/* Empty State */
.lessons-list__empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	text-align: center;
}

.lessons-list__empty-text {
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	margin-bottom: 20px;
}

.lessons-list__empty-btn {
	background-color: #0095ec;
	color: #ffffff;
	border: none;
	border-radius: 8px;
	padding: 12px 24px;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
}

.lessons-list__empty-btn:hover {
	background-color: #0077be;
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 149, 236, 0.3);
}

/* Items */
.lessons-list__items {
	display: flex;
	flex-direction: column;
	gap: 16px;
}
</style>

